import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

export default {
  getChartData: () => request(METHODS.GET, API.CHART.GET_CHART)(),
};
